// views/MainPage/ForgotPasswordPage/ForgotPasswordPage.tsx
import { useState, useEffect, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import styles from '../authShared.module.css';
import { User } from '../../../Entities';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    if (!email) {
      setError('Vyplňte prosím email');
      setIsLoading(false);
      return;
    }
    if (!EMAIL_RE.test(email)) {
      setError('Zadejte platný email');
      setIsLoading(false);
      return;
    }

    try {
      await User.passwordForgotten({ email });
      setMessage('Pokyny pro reset hesla byly odeslány na váš email');
      setIsEmailSent(true);
    } catch (err) {
      console.error(err);
      setError('Nepodařilo se odeslat email. Zkuste to prosím znovu.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isEmailSent) {
    return (
      <div className={styles.authPage}>
        <div className={styles.container}>
          <div className={styles.card}>
            <div className={styles.header}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>📧</div>
              <h1>Email odeslán</h1>
              <p className={styles.subtitle}>Zkontrolujte si svou emailovou schránku</p>
            </div>

            {message && <div className={styles.success}>{message}</div>}
            {error && <div className={styles.error}>{error}</div>}

            <p className={styles.subtitle} style={{ marginBottom: 8 }}>
              Poslali jsme pokyny pro reset hesla na adresu <strong>{email}</strong>
            </p>
            <p className={styles.subtitle} style={{ marginBottom: 20 }}>
              Pokud email nevidíte, zkontrolujte složku spam nebo nevyžádané zprávy.
            </p>

            <button className={styles.btnGhost} onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? 'Odesílání...' : 'Odeslat znovu'}
            </button>

            <div className={styles.altSection}>
              <Link to="/login" className={styles.link}>
                ← Zpět na přihlášení
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.authPage}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1>Zapomenuté heslo</h1>
            <p className={styles.subtitle}>Zadejte svůj email a my vám pošleme pokyny pro reset hesla</p>
          </div>

          {error && <div className={styles.error}>{error}</div>}
          {message && <div className={styles.success}>{message}</div>}

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vas@email.cz"
                disabled={isLoading}
                autoFocus
              />
            </div>

            <button type="submit" className={styles.btnPrimary} disabled={isLoading}>
              {isLoading ? 'Odesílání...' : 'Odeslat pokyny'}
            </button>
          </form>

          <div className={styles.altSection}>
            <p>
              Vzpomněli jste si na heslo?{' '}
              <Link to="/login" className={styles.link}>
                Přihlásit se
              </Link>
            </p>
            <h3>Potřebujete pomoc?</h3>
            <p>
              Pokud máte problémy s resetem hesla, kontaktujte náš tým podpory:{' '}
              <a href="mailto:podpora@algapia.cz" className={styles.link}>
                podpora@algapia.cz
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
